

import Vue from 'vue'
import Vant from 'vant';
import 'vant/lib/index.css';
import App from './App'
import router from './router'
import 'lib-flexible/flexible'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'


import store from './store'
import * as dd from 'dingtalk-jsapi'
import '!style-loader!css-loader!less-loader!./assets/style/common.less'
import '@/permission'


const FastClick = require('fastclick')

Vue.config.productionTip = false
FastClick.attach(document.body)

Vue.use(Vant);
Vue.use(AlertPlugin);
Vue.use(LoadingPlugin);
Vue.use(ConfirmPlugin);
Vue.use(ToastPlugin);

FastClick.prototype.focus = function (targetElement) {
let length;
if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
length = targetElement.value.length;
targetElement.focus();
targetElement.setSelectionRange(length, length);
} else {
targetElement.focus();
}
};



















/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js